var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"Controls","appear":""}},[_c('div',{staticClass:"Controls"},_vm._l((_vm.items),function(item){return (_vm.ready)?_c('div',{staticClass:"Controls__item",class:{ 'selected': _vm.categorie == item.id },on:{"click":function($event){_vm.onClick(item.id)}}},[_vm._v(_vm._s(item.txt[_vm.lang]))]):_vm._e()}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-583b4345","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/defis/components/Controls.vue
// module id = null
// module chunks = 